import type { DocMigration } from "../docMigration";
import { forEachRoom } from "../docMigrationUtils";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_33: DocMigration = {
  maxSchemaVersion: "0.0.33",
  apply(json: any) {
    forEachRoom(json, (room) => {
      if (room.type === "SCREEN_PORCH") {
        room.type = "FRONT_PORCH";
      }
    });
    return json;
  },
};

export default migration_0_0_33;
